import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { TextboxType } from "../textbox/textbox-type.enum";
import { ConfirmNoPageNumberComponent } from "./confirm-no-page-number.component";

export interface IConfirmNoPageNumber extends IDynamicInputOptions {
  type?: TextboxType;
  pageNumber?: number;
  adminValue?: string;
  validationId?: string;
  validationNote?: string;
  dataType?: string;
  autocomplete?: string;
}

export class ConfirmNoPageNumber extends DynamicInput implements IConfirmNoPageNumber {
  type: TextboxType;
  pageNumber: number;
  adminValue: string;
  validationId: string;
  validationNote: string;
  dataType: string;
  autocomplete: string;

  readonly controlType = "text";
  readonly componentType = ConfirmNoPageNumberComponent;

  constructor(options: IConfirmNoPageNumber = {}) {
    super(options);
    this.type = options.type || TextboxType.TEXT;
    this.pageNumber = options.pageNumber;
    this.adminValue = options.adminValue;
    this.validationId = options.validationId;
    this.validationNote = options.validationNote;
    this.dataType = options.dataType;
    this.autocomplete = options.autocomplete || "off";
  }
}
